import React from 'react';

import { HInput, DSelect, passParamsThrough } from '../../../validation/HForm';

const ModalLayout = ({
                         control,
                         register,
                         errors,
                         defaultData,
                         loading,
                         leader,
                         handleOptionsLeader,
                         departments,
                         isMainEnable,
                         handleOptionsBranch,
                     }) => {
    const defaultLeader =
        defaultData && defaultData.directors.map((i) => ({ value: i.id, label: i.fullName }));
    const defaultCashboxes = defaultData?.cashBoxes.map((item) => ({
        value: item.id,
        label: item.name,
    }));
    const defaultBranchValue = defaultData?.branchName;
    const defaultSendUserAllowed = { label:  defaultData?.sendUserAllowed?.fullName, value:  defaultData?.sendUserAllowed?.id };
    const props = {
        control,
        register,
        errors,
    };

    return passParamsThrough(
        <fieldset>
            <div className="form-element">
                <label className="form-element-label" htmlFor="branchId">
                    Название
                </label>
                <div className="form-element-data">
                    <HInput
                        h="true"
                        className="input input-branch"
                        type="text"
                        name="branchName"
                        id="branchId"
                        defaultValue={defaultBranchValue}
                    />
                </div>
            </div>
            <div className="form-element">
                <label className="form-element-label">Директор</label>
                <div className="form-element-data multi-select combobox branch">
                    <DSelect
                        h="true"
                        name="directorIds"
                        isMulti={true}
                        isLoading={loading}
                        options={leader}
                        handleOptions={handleOptionsLeader}
                        defaultValue={defaultLeader}
                        placeholder="Введите имя"
                    />
                </div>
            </div>
            {!isMainEnable && <div className="form-element">
                <label className="form-element-label">Отпуск ТН разрешил</label>
                <div className="form-element-data multi-select combobox branch">
                    <DSelect
                        h="true"
                        name="sendUserAllowed"
                        isLoading={loading}
                        options={leader}
                        handleOptions={handleOptionsLeader}
                        defaultValue={defaultSendUserAllowed}
                        placeholder="Введите имя"
                        isClearable
                    />
                </div>
            </div>}
            <div className="form-element">
                <label className="form-element-label">Подразделения</label>
                <div className="form-element-data multi-select combobox branch">
                    <DSelect
                        h="true"
                        name="listCashboxes"
                        isLoading={loading}
                        options={departments}
                        handleOptions={handleOptionsBranch}
                        isMulti={true}
                        defaultValue={defaultCashboxes}
                        placeholder="Введите название"
                    />
                </div>
            </div>
        </fieldset>,
        props,
    );
};

export default ModalLayout;